import { render, staticRenderFns } from "./BarEchart3.vue?vue&type=template&id=311e1a46"
import script from "./BarEchart3.vue?vue&type=script&lang=js"
export * from "./BarEchart3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports